import { supervisorAxios } from "../axiosInstance";
import { notify } from "../components/toastify";
import { useNavigate } from "react-router";

// let hasNotified = false;
const SupervisorApi = () => {
  const navigate = useNavigate();
  const fetchData = async (endpoint, page = 1, search = "") => {
    try {
      let url = `${endpoint}?page=${page}`;
      if (search) {
        url += `&searchParam=${search}`; // Correctly append search parameter
      }

      const response = await supervisorAxios.post(url, {});
      return response?.data?.data;
    } catch (error) {
      // if (!hasNotified) {
      if (error.response?.status === 401 || error?.status === 401) {
        navigate("/login"); // Redirect to login
        return;
      }
      notify(error?.response?.data?.message || error.message);

      throw new Error(error.response?.data?.message || error.message);
      // throw new Error("Error fetching data" + error.message);
    }
  };

  const fetchOnlyData = async (endpoint) => {
    try {
      let url = `${endpoint}`;

      const response = await supervisorAxios.get(url);

      return response?.data?.data;
    } catch (error) {
      if (error.status === 401 || error.response?.status === 401) {
        navigate("/login"); // Redirect to login
        return;
      }
      notify(error?.response?.data?.message || error.message);

      console.log(error.message);
      throw new Error(error.response?.data?.message || error?.message);
      // throw new Error("Error fetching data" + error.message);
    }
  };
  const fetchPinData = async (endpoint) => {
    try {
      let url = `${endpoint}`;

      const response = await supervisorAxios.get(url, {});
      notify(response?.data?.message, "success");
      return response;
    } catch (error) {
      if (error.status === 401 || error.response?.status === 401) {
        navigate("/login"); // Redirect to login
        return;
      }
      notify(error?.response?.data?.message || error?.message);

      console.log(error?.message);
      throw new Error(error?.response?.data?.message || error?.message);
      // throw new Error("Error fetching data" + error.message);
    }
  };

  const createData = async (endpoint, data, showNotification) => {
    try {
      const response = await supervisorAxios.post(`${endpoint}`, data);
      if (showNotification) {
      } else {
        notify(response?.data?.message, "success");
      }

      return response?.data; // Adjust based on the structure of your response
    } catch (error) {
      if (error.status === 401 || error.response?.status === 401) {
        navigate("/login"); // Redirect to login
        return;
      }
      notify(error?.response?.data?.message || error.message);
      throw new Error(error.response?.data?.message || error.message);
    }
  };

  const updateData = async (endpoint, id, data, showNotification) => {
    try {
      const response = await supervisorAxios.put(`${endpoint}${id}`, data);
      if (showNotification) {
      } else {
        notify(response?.data?.message, "success");
      }

      return response?.data;
      // Adjust based on the structure of your response
    } catch (error) {
      if (error?.response?.status === 401 || error.status === 401) {
        navigate("/login"); // Redirect to login
        return;
      }
      notify(error?.response?.data?.message || error?.message);
      console.log("error mressage:", error);
      throw new Error(error.response?.data?.message || error.message);
    }
  };

  const deleteData = async (endpoint, id) => {
    try {
      const response = await supervisorAxios.delete(`${endpoint}${id}`);
      // console.log(url);
      notify(response?.data?.message, "success");
      return response?.data; // Adjust based on the structure of your response
    } catch (error) {
      notify(error.response.data.message || error.message);
      if (error.status === 401 || error.response?.status === 401) {
        navigate("/login"); // Redirect to login
        return;
      }
      console.log(error?.response.status);

      throw new Error(error.response.status);
    }
  };

  const getDataById = async (endpoint, id) => {
    try {
      const response = await supervisorAxios.get(`${endpoint}${id}`);
      return response; // Adjust based on the structure of your response
    } catch (error) {
      notify(error?.response?.data?.message || error.message);
      console.log("error mressage:", error);
      throw new Error(error.response?.data?.message || error.message);
    }
  };

  return {
    fetchData,
    fetchOnlyData,
    fetchPinData,
    createData,
    updateData,
    deleteData,
    getDataById,
  };
};

export default SupervisorApi;
